export const CACHE_KEY_NOMBRE_ENFANTS = 'campJour_nombreEnfants';

export const MAX_ENFANTS = 100;

export function getCachedNombreEnfants() {
  const cached = sessionStorage.getItem(CACHE_KEY_NOMBRE_ENFANTS);
  if (cached == null || cached === '') return null;
  const num = parseInt(cached, 10);
  if (isNaN(num) || num < 1) return null;
  if (num > MAX_ENFANTS) return String(MAX_ENFANTS);
  return cached;
}
export function setCachedNombreEnfants(value) {
  sessionStorage.setItem(CACHE_KEY_NOMBRE_ENFANTS, value);
}

export function clearCachedNombreEnfants() {
  sessionStorage.removeItem(CACHE_KEY_NOMBRE_ENFANTS);
}